import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { WINDOW } from 'app/services/window.provider';
;
import * as _ from 'underscore';

@Injectable({
    providedIn: 'root'
})
export class PoojaModalService {

    constructor(private http: HttpClient, @Inject(WINDOW) private window: Window) {
    }

    // bookPooja(data): Observable<GenericResponse<any>> {
    //     return this.http.post<GenericResponse<any>>(Api.order, data);
    // }

    // addFamilyMember(data): Observable<GenericResponse<any>> {
    //     return this.http.post<GenericResponse<any>>(`user/family/member/online`, data);
    // }

    fetchOrderStatus(order_id): Observable<any> {
        return this.http.get<any>(`pg/orders/${order_id}`);
    }

}
